import { WORKFLOW_STATUS } from "common/constants";
import { Tag, TagProps } from "../Common/Tag";

type WorkflowStatus = (typeof WORKFLOW_STATUS)[keyof typeof WORKFLOW_STATUS];

const workflowStatusToStyleVariant: Record<
  WorkflowStatus,
  TagProps["styleVariant"]
> = {
  [WORKFLOW_STATUS.LOCKED]: "neutral",
  [WORKFLOW_STATUS.OPEN]: "warning",
  [WORKFLOW_STATUS.COMPLETE]: "default",
  [WORKFLOW_STATUS.REJECTED]: "critical",
};

const workflowStatusDisplayText: Record<WorkflowStatus, string> = {
  [WORKFLOW_STATUS.LOCKED]: WORKFLOW_STATUS.LOCKED,
  [WORKFLOW_STATUS.OPEN]: WORKFLOW_STATUS.OPEN,
  [WORKFLOW_STATUS.COMPLETE]: WORKFLOW_STATUS.COMPLETE,
  [WORKFLOW_STATUS.REJECTED]: WORKFLOW_STATUS.REJECTED,
};

type Props = {
  status: WorkflowStatus;
} & Omit<TagProps, "styleVariant">;

export function WorkflowStatusTag({ status, ...props }: Props) {
  const styleVariant = workflowStatusToStyleVariant[status];
  const displayText = workflowStatusDisplayText[status];

  return (
    <Tag {...props} styleVariant={styleVariant}>
      {displayText}
    </Tag>
  );
}
